import { updateGlobalCSSVars } from "manifest-components/src/Styles/globals";
import User from "manifest-core/classes/employerDashboard/user";
import { Actions, Action } from "./appActions";
import { AppState } from "./appState";

export default (state: typeof AppState, action: Action): typeof AppState => {
  switch (action.type) {
    case Actions.SET_SHOW_FULL_SCREEN_LOADER:
      return {
        ...state,
        showFullScreenLoader: action.payload,
      };
      break;

    case Actions.SET_HEADER_CLASS:
      return {
        ...state,
        headerClass: action.payload,
      };
      break;

    case Actions.UPDATE_GLOBAL_CSS_VAR:
      // Don't trigger a change if they are the same value
      if (state.theme[action.payload.property] === action.payload.value) return state;
      updateGlobalCSSVars(action.payload.property, action.payload.value);
      return {
        ...state,
        theme: {
          ...state.theme,
          [action.payload.property]: action.payload.value,
        },
      };

    case Actions.SET_SHOW_HAMBURGER_MENU:
      return {
        ...state,
        showHamburgerMenu: !action.payload,
      };

    case Actions.GET_USER:
      return {
        ...state,
        user: action.payload,
        fetchingUser: false,
        userFetched: true,
      };

    case Actions.CHANGE_EMAIL:
      return {
        ...state,
        emailAddressChanged: true,
      };

    case Actions.PASSWORD_CHANGED:
      return {
        ...state,
        passwordChanged: true,
      };

    case Actions.FETCHING_USER:
      return {
        ...state,
        fetchingUser: true,
      };

    case Actions.CLEAR_DATA:
      return {
        ...state,
        fetchingUserDetails: false,
        countriesListFetched: false,
        userFetched: false,
        userDetailsFetched: false,
        fetchingUser: false,
        user: {} as User,
      };

    case Actions.SET_NAVIGATION_BLOCKED:
      return {
        ...state,
        navigationBlockedReason: action.payload,
      };

    case Actions.GET_STATES:
      return {
        ...state,
        statesList: action.payload,
        statesListFetched: true,
      };

    default:
      return state;
  }
};
